import { SHADE_FINDER_CONFIGURATION_UNDEFINED } from "../constants/shade-finder.constant";
import {
    ShadeFinderConfigurationState,
    ShadeFinderModalStatus,
    ShadeFinderSdkError,
} from "../types/shade-finder.types";

export interface ShadeFinderCameraDimension {
    width: number;
    height: number;
}

export interface ShadeFinderState {
    shadeFinderConfig: ShadeFinderConfigurationState;
    isApproval: boolean;
    modalStatus: ShadeFinderModalStatus;
    sdkError: ShadeFinderSdkError;
    cameraDimension: ShadeFinderCameraDimension;
}

export const initialState: ShadeFinderState = {
    shadeFinderConfig: SHADE_FINDER_CONFIGURATION_UNDEFINED,
    isApproval: false,
    modalStatus: ShadeFinderModalStatus.NONE,
    sdkError: ShadeFinderSdkError.NO_ERROR,
    cameraDimension: { width: 0, height: 0 },
};
